import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { IChatbotExamEvaluation } from "../../../Components/ChatbotExamEvaluation/IChatbotExamEvaluation";
import {
  successChatbotExamEvaluation,
  failureChatbotExamEvaluation,
} from "./ChatbotExamEvaluationSlicer";

const ChatbotExamEvaluationApi = (
  action: PayloadAction<IChatbotExamEvaluation>
) => {
  return api.post("/api/exam/ai-chatbot", action.payload);
};

export function* ChatbotExamEvaluationCall(
  action: PayloadAction<IChatbotExamEvaluation>
) {
  try {
    const respons: AxiosResponse = yield call(ChatbotExamEvaluationApi, action);
    yield put(successChatbotExamEvaluation(respons.data));
  } catch (error) {
    yield put(failureChatbotExamEvaluation(error));
  }
}
